<div class="dialog-frame" id="iplexGStartDialogFrame">
  <ng-container *ngIf="isConfirmedGuidanceMessage; else guidanceMessage">
    <h2 mat-dialog-title>{{ 'iplexGStartConnectDialogComponent.dialogTitle' | translate }}</h2>
    <div class="container">

      <p class="connexion-confirmation">{{ 'iplexGStartConnectDialogComponent.message1' | translate }}<br>
        {{ 'iplexGStartConnectDialogComponent.message2' | translate }}</p>

      <div class="form-div" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex>
          <mat-label>{{ 'iplexGStartConnectDialogComponent.deviceNamePlaceholder' | translate }}</mat-label>
          <input matInput [maxlength]="clientNameMaxLength" [formControl]="clientNameControl" required>
          <mat-hint align="end">{{ clientNameControl.value?.length || 0 }}/ {{ clientNameMaxLength }}</mat-hint>
          <mat-error *ngIf="clientNameControl.invalid && clientNameControl.hasError('required')">
            {{ 'iplexGStartConnectDialogComponent.clientNameRequiredError' | translate }}
          </mat-error>
          <mat-error *ngIf="clientNameControl.invalid && clientNameControl.hasError('maxlength')">
            {{ 'iplexGStartConnectDialogComponent.clientNameMaxlengthError' | translate: { maxLength: clientNameMaxLength } }}
          </mat-error>
          <mat-error *ngIf="clientNameControl.hasError('pattern') && !clientNameControl.hasError('required')">
            {{ 'iplexGStartConnectDialogComponent.clientNameRegexError' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
      <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">{{ 'iplexGStartConnectDialogComponent.cancel' | translate }}</button>
        <button mat-raised-button [disabled]="clientNameControl.invalid" color="primary" (click)="connect()">
          {{ 'iplexGStartConnectDialogComponent.connect' | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </ng-container>
</div>

<ng-template #guidanceMessage>
    <h2 mat-dialog-title>{{ 'iplexGStartConnectDialogComponent.guidanceMessageTitle' | translate }}</h2>

    <mat-dialog-content class="mat-typography guidance-message-content">
      <p>{{ 'iplexGStartConnectDialogComponent.guidanceMessage1' | translate }}</p>
      <p>{{ 'iplexGStartConnectDialogComponent.guidanceMessage2' | translate }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button mat-button
              mat-dialog-close
              color="primary">{{ 'iplexGStartConnectDialogComponent.cancel' | translate }}</button>
      <button mat-button
              color="primary"
              (click)="confirmGuidanceMessage()">{{ 'iplexGStartConnectDialogComponent.next' | translate }}</button>
    </mat-dialog-actions>
</ng-template>
